import { isRevertSecondFactorPage } from 'shared/utils'
import NeutralPageLoader from './NeutralPageLoader'
import PageLoader, { PageLoaderProps } from './PageLoader'

const StartupPageLoader = (props: PageLoaderProps) =>
  isRevertSecondFactorPage(window.location) ? (
    <NeutralPageLoader />
  ) : (
    <PageLoader {...props} />
  )

export default StartupPageLoader
